/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anspruchkrankentagegeld2Inputs */



/**

* @param {_Field_Anspruchkrankentagegeld2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_anspruchkrankentagegeld2 = /** @type {((inputs?: _Field_Anspruchkrankentagegeld2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anspruchkrankentagegeld2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Anspruch auf Krankentagegeld")
});
export { _field_anspruchkrankentagegeld2 as "_field_anspruchKrankentageGeld" }